<script setup>
/* eslint-disable no-unused-vars */
/* global defineProps, defineEmits */
import HeaderTitle from "@/components/layout/HeaderTitle.vue";
import Service from "@/api/services/benefit";
import Notification from "@/utils/plugins/NotificationService";
import PreviewMediaObjectImage from "@/components/shared/PreviewMediaObjectImage.vue";
import moment from "moment";
import router from "@/app/router/router";

/* import moment from "moment"; */

import { computed, onMounted, ref, watch } from "vue";
import { useAuthStore } from "@/app/stores/authStore";
import { useRoute } from "vue-router";

const props = defineProps({
  benefit: {
    type: Object,
    default: null
  },
  update: {
    type: Boolean,
    default: false
  }
});

const authStore = useAuthStore();

const route = useRoute();

const title = ref("");

const description = ref("");

const status = ref("noactive");

const optionsStatus = ref([]);

const benefits = ref([]);

const fromDate = ref('');

const toDate = ref('');

const mediaObjects = ref([]);

const disableSave = ref(false);

const disableSelect = ref(false);

const contact = ref('');

const company = ref('');

const contactPhone = ref('');

const customToolbar = ref([["bold", "italic", "underline"], [{
  list: "ordered"
}, {
  list: "bullet"
}], [{
  color: []
}, {
  background: []
}, "link"]]);

const isAdmin = computed(() => {
  const user = authStore.getUserLogged;
  return user.roles.includes('ROLE_ADMIN');
});

function getMediaObjects() {
  Service.getMediaObject(route.params.id).then(resp => {
    // console.log("Media Objects",resp);
    mediaObjects.value = resp.data["hydra:member"];
  });
}

function save() {
  if (!title.value) {
    Notification.addNotification("El campo título no debe ser vacío.", "error", 6000);
    return;
  }
  if (route.params.id) updateBenefit();else {
    create();
  }
}

function updateBenefit() {
  const params = {
    title: title.value,
    active: status.value === 'active' ? true : false,
    description: description.value,
    fromDate: fromDate.value,
    toDate: toDate.value,
    contactName: contact.value,
    contactPhone: contactPhone.value,
    company: company.value
  };
  if (mediaObjects.value.length > 0) {
    params.benefitMediaObjects = mediaObjects.value.map(v => v["@id"]);
  }
  disableSave.value = true;
  Service.update(route.params.id, params).then(() => {
    disableSave.value = false;
    router.push({
      name: "benefits-search"
    });
  });
}

function create() {
  const params = {
    title: title.value,
    active: status.value === 'active' ? true : false,
    description: description.value,
    fromDate: fromDate.value,
    toDate: toDate.value,
    contactName: contact.value,
    contactPhone: contactPhone.value,
    company: company.value
  };
  if (mediaObjects.value.length > 0) {
    params.benefitMediaObjects = mediaObjects.value.map(v => v["@id"]);
  }
  disableSave.value = true;
  Service.create(params).then(() => {
    disableSave.value = false;
    router.push({
      name: "benefits-search"
    });
  });
}

function disabledEndDate(date, departureDate) {
  let flag = false;
  // If departureDate then return valid dates after departureDate
  if (departureDate) {
    flag = moment(date.getTime()) < moment(departureDate);
  } else {
    // If !departureDate then return valid dates after today
    flag = moment(date.getTime()) < moment.now();
    /* return date.getTime() < Date.now() */
  }
  return flag;
}

function deleteMedia(id) {
  //console.log("AAAAAA",id);
  Service.deleteMediaObject(id).then(() => {
    //console.log("Delete Media",resp);
    mediaObjects.value = mediaObjects.value.filter(v => v.id != id);
  });
}

function selectFile() {
  var fileSelector = document.createElement("input");
  fileSelector.setAttribute("type", "file");
  fileSelector.addEventListener("change", function (e) {
    //console.log("File",e.target.files);
    /*  var extn = e.target.files[0].type.split("/")[1];*/
    var size = e.target.files[0].size;
    var maxSize = 2097152; // 2097152 byte
    if (size < maxSize) {
      disableSave.value = true;
      Service.createMediaObject(e.target.files[0]).then(resp => {
        //console.log("Add media",resp);
        mediaObjects.value.push(resp.data);
        disableSave.value = false;
      });
    } else {
      Notification.addNotification("No se puede cargar el Archivo porque excede el límite permitido.", "error", 6000);
    }
    /*  _this.urlImage =URL.createObjectURL(e.target.files[0]); */
  });
  fileSelector.click();
  return false;
}

function loadData(sgg) {
  console.log("Data", sgg);
  //console.log("Sugg",sgg);
  title.value = sgg.title;
  description.value = sgg.description;
  status.value = sgg.active ? 'active' : 'noactive';
  fromDate.value = sgg.fromDate;
  toDate.value = sgg.toDate;
  company.value = sgg.company, contact.value = sgg.contactName, contactPhone.value = sgg.contactPhone, getMediaObjects();
}

async function cleanMedia() {
  const prom = [];
  if (mediaObjects.value.length > 0) {
    const haveUndanew = props.benefit && props.benefit.benefitMediaObjects ? true : false;
    mediaObjects.value.forEach(v => {
      if (haveUndanew) {
        const pos = props.benefit.benefitMediaObjects.findIndex(r => r === v["@id"]);
        if (pos === -1) prom.push(deleteMedia(v.id));
      } else {
        prom.push(deleteMedia(v.id));
      }
    });
    console.log("pomess", prom);
    if (prom.length > 0) {
      await Promise.all(prom);
      router.push({
        name: "benefits-search"
      });
    } else {
      router.push({
        name: "benefits-search"
      });
    }
  } else {
    router.push({
      name: "benefits-search"
    });
  }
}

async function goBack() {
  await cleanMedia();
}

watch(mediaObjects, (newVal) => {
  //console.log("VIEWWWWWW",newVal);
  if (newVal.length === 3) {
    disableSelect.value = true;
  }
  if (newVal.length >= 0 && newVal.length < 3) {
    disableSelect.value = false;
  }
});

onMounted(() => {
  if (props.update && props.benefit !== null) {
    loadData(JSON.parse(JSON.stringify(props.benefit)));
  }
});
</script>

<template>
  <div>
    <header-title title="Talento" />
    <div class="d-flex flex-row justify-content-start">
      <img src="@/assets/icons/speaker-icon.svg" width="30" alt="">
      <div class="title-text ml-4">
        BENEFICIOS
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <div class="w-100 label-common">
          <div class="form-item">
            <label for="title" class="w-100">T&iacute;tulo</label>
            <el-input
              id="title"
              v-model="title"
              :placeholder="'Ingrese título'"
            />
          </div>
        </div>
      </div>
      <div class="col-md-2">
          <div class="form-item date-picker  label-common w-100">
          <label
            for="id-improvements"
            class="w-100"
          >Validez Desde</label>
          <el-date-picker
              size="large"
            :ref="'fromDate'"
            v-model="fromDate"
            :name="'from-date'"
            type="date"
            format="DD/MM/YYYY"
            value-format="YYYY-MM-DD"
            :prefix-icon="'el-icon-date'"
            :picker-options="{ firstDayOfWeek: 1 }"
          />
        </div>
      </div>
      <div
          class="col-md-2 label-common"
      >
        <div class="form-item date-picker w-100">
          <label
              for="id-status"
              class="w-100"
          >Hasta</label>
          <el-date-picker
              size="large"
              :ref="'toDate'"
              v-model="toDate"
              :name="'to-date'"
              type="date"
              format="DD/MM/YYYY"
              value-format="YYYY-MM-DD"
              :prefix-icon="'el-icon-date'"
              :picker-options="{ firstDayOfWeek: 1,disabledDate:(time)=>disabledEndDate(time,fromDate)}"
          />
        </div>
      </div>
    </div>
    <div class="row">
      <div
          class="col-md-8 label-common"
      >
        <div class="form-item">
          <label
              for="id-status"
              class="w-100"
          >Empresa</label>
          <el-input
              id="title"
              v-model="company"
              :placeholder="'Ingrese empresa'"
          />
        </div>
      </div>
      <div
        class="col-md-4 label-common"
      >
        <div class="form-item">
          <label for="title" class="w-100">Estado</label>
          <el-radio-group
            v-model="status"
            class="ml-4"
          >
            <el-radio
              label="active"
              size="large"
            >
              Activo
            </el-radio>
            <el-radio
              label="noactive"
              size="large"
            >
              No activo
            </el-radio>
        </el-radio-group>
        </div>
      </div>


    </div>
    <div class="row">
      <div
        class="col-md-6 label-common"
      >
        <div class="form-item">
        <label
          for="id-status"
          class="w-100"
        >Nombre contacto</label>
        <el-input
          id="title"
          v-model="contact"
          :placeholder="'Ingrese contacto'"
        />
        </div>
      </div>
      <div
        class="col-md-6 label-common"
      >
        <div class="form-item">
        <label
          for="id-status"
          class="w-100"
        >Tel&eacute;fono contacto</label>
        <el-input
          id="title"
          v-model="contactPhone"
          :placeholder="'Ingrese telefono'"
        />
        </div>
      </div>
    </div>

    <div class="row ml-1 mt-5 mb-4 label-common">
      <label class="w-100">Descripci&oacute;n</label>
      <QuillEditor   contentType="html" v-model:content="description" theme="snow" />
    </div>


    <el-row class="label-common">
      <el-col :span="8">
        <div class="d-flex flex-nowrap flex-column mt-4 w-100 label-common">
          <label>Imagen (300*300)</label>

          <PreviewMediaObjectImage
            :media-object="mediaObjects"
            @deleteMediaObject="(id) => deleteMedia(id)"
          />

          <button
            :disabled="disableSelect"
            class="btn btn-block btn_yellow mt-4"
            style="width: 300px"
            @click="selectFile()"
          >
            Seleccionar
          </button>
        </div>
      </el-col>
    </el-row>
    <div class="d-flex justify-content-end">
      <button
        class="btn btn_yellow btn-search"
        :disabled="disableSave"
        @click="goBack()"
      >
        VOLVER
      </button>
      <button
        class="btn btn_red btn-search ml-4"
        @click="save()"
      >
        GUARDAR
      </button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.btn-search {
  &.btn_yellow {
    color: $bg-blue;
  }
  &.btn_red {
    color: white;
  }
  width: 20em;
  height: 3em;

  font-weight: bolder;
  text-transform: uppercase;
  width: 200px;
  height: 40px;
}
.label-common {
  label {
    font-size: 20px;
    font-weight: 800;
    letter-spacing: -2px;
  }
}
.card-search {
  border-radius: 15px;
  height: 150px;
  background: url("../../assets/icons/altavoz.png"), white;
  background-repeat: no-repeat;
  background-position-x: 100%;
  overflow: visible !important;
}
#icon-search {
  fill: $bg-blue;
  width: 6%;
}
#icon-search-calendar {
  fill: $bg-blue;
  width: 120px;
  height: 20px;
}
.table-users {
  table {
    thead {
      tr {
        th {
          padding: 0px !important;
          margin: 0px !important;
        }
      }
      #icon-search {
        fill: $bg-blue;
        width: 20px;
      }
      #icon-user {
        fill: $bg-blue;
        width: 1.6em;
      }
    }
    tbody {
      td {
        .link-name {
          margin: auto;
          margin-left: 10px;
        }
      }
    }
  }
}
</style>
